module.exports = __webpack_public_path__ + "assets/41088cf24211efc684479b712a9bc462.mp3";